import { getOrganizationViewUrl } from '../../../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../../../utils/routing/reactRoute'
import { withAnalyticsTracking } from '../../../utils/withAnalyticsTracking'
import { StaticActionHandler } from '../actionHandlers'
import { TransactionsBillsActionType } from '../utils/getBillsActions'

/* When customer goes to edit-credit-duplicate bill from transactions list, we pass query params along */
/* If customer clicks `back`, params are filtering the list appropriately */
const dropSortParams = (locationSearch: string): string => {
  const params = new URLSearchParams(locationSearch)
  params.delete('sortProperty')
  params.delete('sortDirection')

  const stripped = params.toString()
  return stripped ? `?${stripped}` : ''
}

export const billActionHandlers: Record<TransactionsBillsActionType, StaticActionHandler> = {
  [TransactionsBillsActionType.Edit]: withAnalyticsTracking(
    ({ originatorId, organizationUrl, locationSearch, transitionTo }) =>
      transitionTo(
        `${getOrganizationViewUrl(organizationUrl, reactRoute.organization.bills.getEditBillRoute(originatorId))}${dropSortParams(locationSearch)}`,
      ),
    'Bills',
    TransactionsBillsActionType.Edit,
  ),

  [TransactionsBillsActionType.Credit]: withAnalyticsTracking(
    ({ originatorId, organizationUrl, locationSearch, transitionTo }) =>
      transitionTo(
        `${getOrganizationViewUrl(organizationUrl, reactRoute.organization.bills.getCreateCreditNoteRoute(originatorId))}${dropSortParams(locationSearch)}`,
      ),
    'Bills',
    TransactionsBillsActionType.Credit,
  ),

  [TransactionsBillsActionType.Duplicate]: withAnalyticsTracking(
    ({ originatorId, organizationUrl, locationSearch, transitionTo }) =>
      transitionTo(
        `${getOrganizationViewUrl(organizationUrl, reactRoute.organization.bills.getDuplicateRoute(originatorId))}${dropSortParams(locationSearch)}`,
      ),
    'Bills',
    TransactionsBillsActionType.Duplicate,
  ),

  [TransactionsBillsActionType.RegisterPayment]: withAnalyticsTracking(
    ({ handleRegisterPaymentForBill }) => {
      handleRegisterPaymentForBill()
    },
    'Bills',
    TransactionsBillsActionType.RegisterPayment,
  ),

  [TransactionsBillsActionType.Void]: withAnalyticsTracking(
    ({ openModal, voidBillModalId }) => {
      openModal(voidBillModalId)
    },
    'Bills',
    TransactionsBillsActionType.Void,
  ),

  [TransactionsBillsActionType.VoidPayment]: withAnalyticsTracking(
    ({ openModal, voidBillPaymentModalId }) => {
      openModal(voidBillPaymentModalId)
    },
    'Bills',
    TransactionsBillsActionType.VoidPayment,
  ),
}
